// Copyright (c) 2025 GeoVerses. All rights reserved.

import React from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import SignIn from './SignIn';

const PoemEditor = ({
  user, onSignIn, onEmailSignIn, onEmailSignUp, onSignOut,
  userPoemTitle, userPoemAuthor, userPoemBody,
  onTitleChange, onAuthorChange, onBodyChange,
  onSubmitPoem, successOpen, onSuccessClose
}) => {
  if (!user) {
    return (
      <div className="page-container">
        <Typography variant="h5" component="h1" sx={{ my: 2 }}>Write</Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>Sign in to write a poem</Typography>
        <SignIn onGoogleSignIn={onSignIn} onEmailSignIn={onEmailSignIn} onEmailSignUp={onEmailSignUp} />
      </div>
    );
  }

  return (
    <div className="page-container">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', marginTop: '8px' }}>
        <Typography variant="body2">Signed in as {user.displayName || user.email}</Typography>
        <Button size="small" onClick={onSignOut}>Sign out</Button>
      </div>
      <div className="poem-text-box">
        <label>
          Title
          <input
            className="poem-entry-field"
            name="title"
            type="text"
            value={userPoemTitle}
            onChange={onTitleChange}
          />
        </label>
        <label>
          Author
          <input
            name="author"
            className="poem-entry-field"
            type="text"
            onChange={onAuthorChange}
            value={userPoemAuthor}
          />
        </label>
        <label className="poem-body-field">
          Write a poem!
          <textarea
            name="body"
            className="poem-entry-field"
            variant="filled"
            onChange={onBodyChange}
            value={userPoemBody}
            wrap="off"
            rows="10"
          />
        </label>
        <Button
          variant="contained"
          type="submit"
          onClick={onSubmitPoem}
        >
          Submit Poem
        </Button>
      </div>
      <Dialog open={successOpen} onClose={onSuccessClose}>
        <DialogTitle>Success</DialogTitle>
        <DialogContent>
          <Typography variant="body1">Poem submitted successfully!</Typography>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={onSuccessClose}>OK</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default PoemEditor;
